module.exports = __webpack_public_path__ + "img/3.02b0ddf9.jpg";